import { DateOfBirthAndCityType } from "../../types/commonTypes/dateOfBirthAndCity";

export const initialDateOfBirthAndCityState: DateOfBirthAndCityType = {
    dateOfBirth: "",
    postalCode: "",
    cities: [],
    city: ""
}